// Tipos para o Cadastro de Perfis N1

export interface IPerfil {
  idPerfil?: number;
  codigo: string;
  codigoInterno?: string;
  descricao: string;
  idSituacao: number;
  idStatus: number;
  idReferencia?: number;
  idLinha?: number;
  pesoKgPorMetro?: number;
  idUnidadeValor: number;
  idPrenativo?: number;
  idClasseId?: number;
  tipoPerfil: TipoPerfil;
  idLiga?: number;
  idTempera?: number;
  
  // Campos da aba GERAL
  maisTamanhoBarra?: boolean;
  tamanhoBarra?: number;
  ipi?: number;
  considerarPerda?: boolean;
  
  // Dados Adicionais (aba LIGA/TEMPERA)
  wxt?: number;
  wy?: number;
  jxt?: number;
  jy?: number;
  perimetroTotal?: number;
  perimetroTratamento?: number;
  
  // Tamanhos de Barras
  tamanhoBarras: ITamanhoBarra[];
  
  // Composição (apenas para tipo "composto")
  composicao?: IPerfilComponente[];
  
  // Mídias
  iconeUrl?: string;
  iconeNomeArquivo?: string;
  figuraUrl?: string;
  figuraNomeArquivo?: string;
  desenhoTecnicoUrl?: string;
  desenhoTecnicoNomeArquivo?: string;
  
  // Auditoria
  dataUltimaAtualizacao?: string;
  dataCriacao?: string;
  
  // Campos extras (já existentes na entidade)
  perfilComposto?: number;
  editavel?: boolean;
  excluido?: boolean;
  desconsiderarPerdaBarra?: boolean;
}

export interface ITamanhoBarra {
  id?: number;
  sequencia: number;
  comprimento: number;
}

export interface IPerfilComponente {
  id?: number;
  codigoComponente: string;
  descricaoComponente: string;
  tipoPerfilComponente: 'cor_unica' | 'interno' | 'externo';
  idPerfilComponente?: number;
  sequencia?: number;
}

// FASE 05 — 3ª validação/PO 2026-07-28 (Frente 6): a opção "Não" saiu da lista (reversão da
// P1 de 24/07, registrada em docs/DECISOES.md 26/07) e o default de cadastro novo passou a
// ser "Cor Única". O valor 'nao' permanece no tipo apenas para abrir sem erro cadastros que
// chegaram a ser gravados com ele.
export type TipoPerfil = 'nao' | 'interno' | 'externo' | 'composto' | 'cor_unica';

export const TIPO_PERFIL_OPTIONS = [
  { value: 'interno', label: 'Interno' },
  { value: 'externo', label: 'Externo' },
  { value: 'composto', label: 'Composto' },
  { value: 'cor_unica', label: 'Cor Única' },
];

// Opções de Situação
// FASE 05 — 4ª validação/D3 2026-07-30: semântica legada — 3 = Disponível mercado,
// 4 = Indisponível (fora do fluxo), 5 = Homologado (estado novo do fluxo).
export const SITUACAO_OPTIONS = [
  { id: 1, label: 'Em edição' },
  { id: 2, label: 'Em homologação' },
  { id: 3, label: 'Disponível mercado' },
  { id: 4, label: 'Indisponível' },
  { id: 5, label: 'Homologado' },
];

// Opções de Status
// FASE 05 — 2ª validação/PO 2026-07-24 (F13): "Inativo" removido — no MOF novo só existem
// Ativo e Descontinuado (a base não é alterada; ver decisão P5).
export const STATUS_OPTIONS = [
  { id: 1, label: 'Ativo' },
  { id: 2, label: 'Descontinuado' },
];

// Opções de Unidade de Valorização
export const UNIDADE_VALORIZACAO_OPTIONS = [
  { id: 1, label: 'KG' },
  { id: 2, label: 'Metro' },
  { id: 3, label: 'Barra' },
];

// Interface para selects de referência
export interface ISelectOption {
  id: number;
  nome: string;
  descricao?: string;
}

// Interface para o formulário
export interface IPerfilFormData {
  codigo: string;
  codigoInterno?: string;
  descricao: string;
  idSituacao: number;
  idStatus: number;
  idReferencia?: number;
  idLinha?: number;
  pesoKgPorMetro?: number;
  idUnidadeValor: number;
  idPrenativo?: number;
  idClasseId?: number;
  tipoPerfil: TipoPerfil;
  idLiga?: number;
  idTempera?: number;
  wxt?: number;
  wy?: number;
  jxt?: number;
  jy?: number;
  perimetroTotal?: number;
  perimetroTratamento?: number;
  desconsiderarPerdaBarra?: boolean;
}

// Tab index
export type PerfilTabIndex = 0 | 1 | 2 | 3;
export const PERFIL_TABS = ['FICHA', 'TAMANHOS DE BARRAS', 'DADOS ADICIONAIS', 'COMPOSIÇÃO'] as const;
